import React from 'react'
// import { Link as RouterLink } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { animateScroll as scroll } from 'react-scroll'
import Button from '@material-ui/core/Button'
import Copy from './Copy'
import PrerollSection from './PrerollSection'

class Preroll extends React.Component {
	constructor() {
		super()
		this.scrollToTop = this.scrollToTop.bind(this)
	}

	componentDidMount() {
		this.scrollToTop()
	}

	scrollToTop() {
		scroll.scrollToTop()
	}

	render() {
		const { classes } = this.props

		return (
			<div className={classes.container} id={'containerElement'}>
				<PrerollSection
					first
					section={''}
					nextSection={'sectionTwo'}
					copySections={[
						<Typography gutterBottom={true} paragraph={true} variant={'h3'}>
							Dear Carolyn,
						</Typography>,
						<Copy mb>
							Cards only go so far. I wanted to give you something to share with
							friends, family, and everyone else you know that expresses how
							much I love you. Try putting this in your memory&nbsp;box!
						</Copy>
					]}
				/>

				<PrerollSection
					section={'sectionTwo'}
					nextSection={'sectionThree'}
					copySections={[
						<Copy mb>
							You've stuck with me for over four years &mdash; through good and
							bad haircuts, many solid colored t&ndash;shirts, and countless
							loads of&nbsp;laundry.
						</Copy>,
						<Copy mb>
							With you by my side, I've become more mature, more confident, and
							more open. You have always shown a true, genuine interest in
							things I care about &mdash; which means more to me than
							you&nbsp;know.
						</Copy>
					]}
				/>

				<PrerollSection
					section={'sectionThree'}
					nextSection={'sectionFour'}
					copySections={[
						<Copy mb>
							You're the most caring person I've ever met. You often put your
							needs second to others (including mine), which is a testament to
							your&nbsp;selflessness.
						</Copy>,
						<Copy mb>
							Your ability to maintain so many close friendships is truly
							incredible, and I'm often in awe of how you balance your time
							between me, work, and&nbsp;friends.
						</Copy>
					]}
				/>

				<PrerollSection
					section={'sectionFour'}
					nextSection={'sectionFive'}
					copySections={[
						<Copy mb>
							You're the first person I want to see when I wake up, and the last
							one I want to see when I go to bed. You are my better half, my
							sounding board, my voice of reason, and my&nbsp;rock.
						</Copy>,
						<Copy mb>
							I'm excited, nervous, and anxious all at once &mdash; but I know
							that as long as we're together, nothing can break us apart. You're
							the strong&nbsp;side to my left&nbsp;side, the over to my under,
							and the fish to my chips.
						</Copy>
					]}
				/>

				<PrerollSection
					section={'sectionFive'}
					nextSection={'sectionSix'}
					copySections={[
						<Copy mb>
							I promise to always make you smoothies for breakfast, try not to
							doze off at Yom Kippur services, and give you five more minutes
							when you fall asleep on the&nbsp;couch.
						</Copy>,
						<Copy mb>
							And I promise to never use the wrong set of dishes, leave the
							apartment with a messy bed, or get mad when you fall asleep on
							the&nbsp;couch.
						</Copy>
					]}
				/>

				<PrerollSection
					last
					section={'sectionSix'}
					nextSection={''}
					copySections={[
						<Copy mb>
							I know you say I never post anything, so I hope this makes up for
							all those missed opportunities. I love you so much and can't wait
							to spend the rest of my life with&nbsp;you!{' '}
							{/*I've curated a collection of our
							best photos &mdash; from Old Forge to Mystic, Yankee Stadium to
							Madison Square Garden, Miami to Colorado, and
							eveywhere&nbsp;in&#8209;between.*/}
						</Copy>,
						<Copy mb>
							Love you always,
							<br />
							Jeremy
						</Copy>
					]}
				/>

				{/* <PrerollSection
					last
					section={'sectionSeven'}
					nextSection={'sectionEight'}
					copySections={[
						<Copy mb>
							I love you so much and can't wait to spend the rest of my life
							with&nbsp;you!
						</Copy>,
						<Copy mb>
							Love you always,
							<br />
							Jeremy
						</Copy>,
						<RouterLink className={classes.link} to="/photos">
							<Button color={'primary'} variant={'contained'}>
								See photos
							</Button>
						</RouterLink>,
						<br />
					]}
				/> */}

				<PrerollSection
					last
					section={'sectionSeven'}
					nextSection={''}
					copySections={[
						<Copy mb>
							You didn't think I was going to use our nicknames, did you?
						</Copy>,
						<Button onClick={this.scrollToTop} color={'primary'}>
							Back to top
						</Button>
					]}
				/>
			</div>
		)
	}
}

export default withStyles(theme => ({
	container: {
		display: 'grid',
		textAlign: 'center',
		margin: '15% 8%',
		[theme.breakpoints.down('xs')]: {
			padding: '10% 5%',
			margin: '15% 0%'
		}
	},
	link: {
		textDecoration: 'none'
	}
}))(Preroll)
